import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import YDocReviewAwardBanner from 'www/vue_components/common/YDocReviewAwardBanner/YDocReviewAwardBanner.vue'
import { initI18n } from 'www/utils'

const el = document.querySelector('.vue-ydoc-review-award-banner-mount')

const mountAwardBanner = async () => {
  await initI18n({ bundle: 'vue_components/common/YDocReviewAwardBanner' })

  if (el) {
    new Vue({
      el,
      vuetify,
      components: { YDocReviewAwardBanner },
    })
  }
}

mountAwardBanner()
